export const DEFAULT_URL_LOCALE = 'en-GB';
export const DEFAULT_URL_COUNTRY_NAME = 'United Kingdom';
export const DEFAULT_URL_COUNTRY_CODE = 'GB';
